import './PersonalSubscriptionSnippet.sass';

import React, { FC, useCallback } from 'react';
import { useRouter } from 'react-router5';

import { PersonalSubscriptionSnippetProps } from './PersonalSubscriptionSnippet.interface';
import { useCurrentLang, useTranslator, useUserInfo } from '$hooks';
import { SUBSCRIPTION_AUTHOR } from '$shared/constants/pages';
import { SubscriptionIcon, UnitName } from '$shared/components';
import { SubscriptionType } from '$store/models';
import { IcAngleRight16 } from '$assets';
import classNames from 'classnames';
import { incline } from 'lvovich';
import { transliterate } from '$utils';
import { useDispatch } from 'react-redux';
import { postsActions } from '$store/posts';

export const PersonalSubscriptionSnippet: FC<PersonalSubscriptionSnippetProps> = ({
  link,
  isSingle,
  adId = 0,
}) => {
  const t = useTranslator();
  const router = useRouter();
  const currentLang = useCurrentLang();
  const isRU = currentLang.key === 'ru';
  const user = useUserInfo(link.object.id);
  const dispatch = useDispatch();

  const handleClick = useCallback(
    (e) => {
      try {
        e.stopPropagation();
      } catch (e) {}
      router.navigate(SUBSCRIPTION_AUTHOR, { authorId: link.object.id });

      if (adId > 0) {
        dispatch(postsActions.sendAdConversion({ adId }));
      }
    },
    [link, adId],
  );

  return (
    <div
      className={classNames('PersonalSubscriptionSnippet', {
        _isSingle: isSingle,
      })}
      onClick={handleClick}
    >
      <div className="PersonalSubscriptionSnippet__content">
        <SubscriptionIcon type={SubscriptionType.Author} authorId={0} />
        <div className="PersonalSubscriptionSnippet__description">
          <div className="PersonalSubscriptionSnippet__name">
            <UnitName unit={link.object} />
          </div>
          {t('subscription_private_caption', {
            name: isRU
              ? incline(
                  {
                    first: user.firstName ?? '',
                  },
                  'instrumental',
                ).first
              : transliterate(user.firstName),
          })}
        </div>
      </div>
      <div className="PersonalSubscriptionSnippet__button">
        <IcAngleRight16 />
      </div>
    </div>
  );
};
